import { storeStructure } from '../store/reducers';
import stepsLive from './formGroupLiveSteps/formGroup0LiveSteps';
import formGroup1Status from './formGroupLiveSteps/formGroupStep5Status/formGroup1Status';

export default {
  title: 'Live template Edit',
  attributeName:'livetemplate',
  createURL: 'livetemplate',
  sessionParams: [],
  getURL: 'livetemplate',
  updateURL: 'livetemplate',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formGroup1Status,
  ],
  stepConfig: stepsLive,

};
